// ⋯ → Add late fee manually (Out & overdue). Replaces the two prompt()
// calls; same route as before (charge-late-fee → computeTotals).
import React, { useState } from 'react';
import axios from '../../lib/axiosClient';
import { UI, fmtMoney, useIsNarrow } from './pipeline';

export default function LateFeeDialog({ order, onClose, onDone, showFlash }) {
  const narrow = useIsNarrow();
  const [amount, setAmount] = useState('');
  const [reason, setReason] = useState('Late return');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState(null);
  const amt = Number(amount);
  const canSave = amt > 0 && !busy;

  async function save() {
    setBusy(true); setErr(null);
    try { await axios.post(`/api/rentals/orders/${order.id}/charge-late-fee`, { amount: amt, reason }); onDone(); }
    catch (e) { const d = e.response?.data || {}; setErr(d.error || 'Failed'); setBusy(false); showFlash?.(d.error || 'Failed', 'error'); }
  }

  return (
    <div style={UI.overlay(narrow)} onClick={e => e.target === e.currentTarget && onClose()}>
      <div style={UI.box(narrow, 400)} data-testid="late-fee-dialog" role="dialog">
        <div style={UI.head}>
          <div><div style={UI.title}>Add late fee</div><div style={UI.sub}>{order.order_number || '#' + order.id} · current late fee {fmtMoney(order.late_fee)}</div></div>
          <button style={UI.close} onClick={onClose} aria-label="Close">✕</button>
        </div>
        <div style={UI.body}>
          <label style={{ ...UI.lbl, marginTop: 0 }}>Amount ($)</label>
          <input type="number" min="0" step="0.01" value={amount} onChange={e => setAmount(e.target.value)} style={UI.inp} placeholder="0.00" />
          <label style={UI.lbl}>Reason</label>
          <input value={reason} onChange={e => setReason(e.target.value)} style={UI.inp} />
          {err && <div style={{ marginTop: 10, color: '#f87171', fontSize: 12 }}>{err}</div>}
        </div>
        <div style={UI.foot}>
          <button style={UI.cancelBtn} onClick={onClose}>Back</button>
          <button disabled={!canSave} onClick={save} style={UI.goBtn(canSave, '#451a03', '#fbbf24')}>{busy ? 'Adding…' : 'Add fee'}</button>
        </div>
      </div>
    </div>
  );
}
